import styled from 'styled-components';

import { getTheme } from '../../util/theme';

export const AdvancedSearchFormStyles = styled.section`
  width: 100%;

  .search-form {
    &--advanced {
      display: flex;
      flex-direction: column;
      margin-left: auto;
      margin-right: auto;
      max-width: 30rem;
      position: relative;
      width: 100%;

      .react-datepicker-wrapper,
      .react-datepicker__input-container {
        width: 100%;
      }

      .date-input {
        border: 1px solid ${getTheme('grey')};
        border-radius: ${getTheme('quarterSpace')};
        font-size: 0.875rem;
        outline: none;
        padding: ${getTheme('halfSpace')};
        width: 100%;

        &:focus {
          border: 2px solid ${getTheme('primaryBlue')};
        }
      }
    }

    &__fieldset {
      margin-bottom: ${getTheme('space')};
    }

    &__legend {
      font-weight: 700;
      margin-bottom: ${getTheme('halfSpace')};
    }

    &__list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    &__item {
      margin-bottom: ${getTheme('halfSpace')};
      position: relative;

      &.full {
        flex-basis: 100%;
      }

      &.half {
        flex-basis: calc(50% - ${getTheme('quarterSpace')});
      }
    }

    &__label {
      background-color: ${getTheme('white')};
      font-size: 0.75rem;
      left: ${getTheme('halfSpace')};
      padding: ${getTheme('eighthSpace')};
      position: absolute;
      top: -0.75rem;
      z-index: 1;

      &.active {
        color: ${getTheme('primaryBlue')};
      }
    }

    &__input {
      border: 1px solid ${getTheme('grey')};
      border-radius: ${getTheme('quarterSpace')};
      font-size: 0.875rem;
      outline: none;
      padding: ${getTheme('halfSpace')};
      width: 100%;

      &:focus {
        border: 2px solid ${getTheme('primaryBlue')};
      }
    }

    &__select {
      background: transparent;
      font-size: 0.875rem;
      height: 2.66rem;
      outline: none;
      width: 100%;

      &:focus {
        border: 2px solid ${getTheme('primaryBlue')};
      }
    }

    &__button {
      align-self: center;
      background-color: transparent;
      border: 2px solid ${getTheme('primaryBlue')};
      color: ${getTheme('primaryBlue')};
      font-weight: 700;
      outline: none;
      padding: ${getTheme('halfSpace')};
      text-transform: uppercase;
      transition: background-color 0.2s ease-out, color 0.2s ease-out;
      width: ${getTheme('fourxSpace')};
      -webkit-appearance: none;

      &:hover,
      &:focus {
        background-color: ${getTheme('primaryBlue')};
        border: 2px solid ${getTheme('primaryBlue')};
        color: ${getTheme('white')};
        font-weight: 700;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/AdvancedSearchForm/styled-components.js